var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"down-gif","appear":""}},[_c('img',{staticClass:"img-fluid down-gif-img",attrs:{"src":require("@/assets/images/down.gif"),"width":"150","height":"150"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }